export function getCurrentEnvironment(): string {
  const url = new URL(window.location.href);
  const currentUrl = url.origin;

  if (currentUrl.includes('local') || currentUrl.includes('dev')) return 'dev';
  else if (currentUrl.includes('staging') && currentUrl.includes('munis-perf-sellside')) return 'perf';
  else if (currentUrl.includes('staging')) return 'staging';
  else return 'prod';
}
